import PropTypes from "prop-types";
import React from "react";

import { RoleShape } from "../../policies/proptypes";

const RoleItem = ({ role, setCurrent, selected }) => (
  <li className="p-list__item">
    <button
      className={`p-button--list ${selected ? "is-selected" : ""}`}
      type="button"
      onClick={() => setCurrent(role.$uri)}
    >
      {role.name}
    </button>
  </li>
);

RoleItem.propTypes = {
  role: RoleShape.isRequired,
  setCurrent: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired
};

export default RoleItem;
